import React from "react";
import { PanelsTopLeft, Settings2 } from "lucide-react";
import PawMark from "@/components/PawMark";
import { ReactComponent as ProfileGlyph } from "@/assets/navigation/profile.svg";
import { ReactComponent as TodayGlyph } from "@/assets/navigation/today.svg";
import { ReactComponent as TeamGlyph } from "@/assets/navigation/team.svg";
import { ReactComponent as WorkspaceGlyph } from "@/assets/navigation/workspace.svg";
import { ReactComponent as HiringGlyph } from "@/assets/navigation/hiring.svg";

const glyphs = {
  today: TodayGlyph,
  team: TeamGlyph,
  workspace: WorkspaceGlyph,
  profile: ProfileGlyph,
  hiring: HiringGlyph,
  settings: Settings2,
};

export default function TotoNavigationGlyph({ name, size = 28 }) {
  if (name === "toto") {
    return <PawMark size={size} color="currentColor" />;
  }

  const Glyph = glyphs[name] || PanelsTopLeft;
  return <Glyph width={size} height={size} aria-hidden="true" focusable="false" />;
}
